export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    /** Serverin xəta kodu (məs. discount_limit, return_pin, pin_locked). */
    readonly code?: string,
  ) {
    super(message);
  }
}

// Eyni mənşəli sorğu: sessiya cookie-si brauzer tərəfindən avtomatik göndərilir.
export async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (res.status === 204) return undefined as T; // yalnız void cavabları üçün (çıxış)
  const data = (await res.json().catch(() => ({}))) as { message?: string | string[] };
  if (!res.ok) {
    const message = Array.isArray(data.message) ? data.message.join(', ') : data.message;
    throw new ApiError(res.status, message ?? 'Xəta baş verdi', (data as { code?: string }).code);
  }
  return data as T;
}

export function withQuery(path: string, params: Record<string, string | number | undefined>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== '') sp.set(k, String(v));
  }
  const qs = sp.toString();
  return qs ? `${path}?${qs}` : path;
}

// Excel faylı xam gövdə kimi göndərilir (multipart yoxdur). Səhv mesajı serverdən.
export async function upload<T>(path: string, file: File, extraHeaders: Record<string, string> = {}): Promise<T> {
  const res = await fetch(path, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': file.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'X-File-Name': encodeURIComponent(file.name),
      ...extraHeaders,
    },
    body: file,
  });
  const data = (await res.json().catch(() => ({}))) as { message?: string | string[] };
  if (!res.ok) {
    const message = Array.isArray(data.message) ? data.message.join(', ') : data.message;
    throw new ApiError(res.status, message ?? 'Xəta baş verdi', (data as { code?: string }).code);
  }
  return data as T;
}
